import { render, staticRenderFns } from "./ClinicProfile.vue?vue&type=template&id=b6d4895e&"
import script from "./ClinicProfile.vue?vue&type=script&lang=js&"
export * from "./ClinicProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClinicProfile.vue?vue&type=style&index=0&id=b6d4895e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports